export default class RtkBase {
  static fromApi(casterBaseItem) {
    let base = new RtkBase()
    base.mountpoint = casterBaseItem.id
    base.username = casterBaseItem.owner
    base.visibility = casterBaseItem.visibility
    base.sessions = casterBaseItem.sourceSessions.items

    return base
  }

  getConnectedSession() {
    if (Array.isArray(this.sessions)) {
      for (let i = 0; i < this.sessions.length; i++) {
        const item = this.sessions[i]
        const status = item.status
        if (status === 'CONNECT') {
          return item
        }
      }
    }
    return null
  }

  getStatus() {
    const connectedSession = this.getConnectedSession()
    if (connectedSession) {
      return 'Online'
    }
    return 'Offline'
  }

  isOnline() {
    const status = this.getStatus()
    if (status) {
      return 'Online' === status
    }
  }
}
